<div>
  <ul class="work-categories__list row" *ngIf="hasWorkCategories; else noCategories">
    <li class="work-categories__list__item col-md-6" *ngFor="let row of selectedWorkCategories">
      <b>{{ row.segmentTitle }}</b> {{getDisplayString(row) }}
    </li>
  </ul>
  <ng-template #noCategories>
    <em class="text-danger">*No work categories defined. At least one work category is required.</em>
  </ng-template>  
</div>